(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-scooter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupHomeScooters = (root = document) => {
      root.querySelectorAll('[data-home-scooter]').forEach((container) => {
        if (container.dataset.homeScooterReady === 'true') return;
        container.dataset.homeScooterReady = 'true';

        const heroImage = container.querySelector('[data-home-scooter-image]');
        const navItems = Array.from(container.querySelectorAll('[data-home-scooter-nav]'));
        const contentBlocks = Array.from(container.querySelectorAll('[data-home-scooter-block]'));
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        let currentIndex = 0;
        let currentDevice = mediaQuery.matches ? 'mobile' : 'desktop';
        let autoplayTimer = null;
        let isPaused = false;

        const autoplayEnabled = container.dataset.autoplayEnabled === 'true';
        const autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) * 1000 || 4000;

        const getDevice = () => mediaQuery.matches ? 'mobile' : 'desktop';

        const setActiveState = (index) => {
          contentBlocks.forEach((block) => {
            block.classList.toggle('active', Number(block.dataset.index) === index);
          });
          navItems.forEach((item) => {
            item.classList.toggle('active', Number(item.dataset.index) === index);
          });
        };

        const swapImage = (navItem, device, forceUpdate) => {
          if (!heroImage || !navItem) return;

          const imageUrl = device === 'mobile' ? navItem.dataset.mobileSrc || navItem.dataset.desktopSrc : navItem.dataset.desktopSrc || navItem.dataset.mobileSrc;
          const imageSrcset = device === 'mobile' ? navItem.dataset.mobileSrcset || navItem.dataset.desktopSrcset : navItem.dataset.desktopSrcset || navItem.dataset.mobileSrcset;

          if (!imageUrl) return;
          if (!forceUpdate && heroImage.getAttribute('src') === imageUrl) return;

          const nextImage = new Image();
          const applyImage = () => {
            heroImage.style.opacity = '0';
            window.setTimeout(() => {
              heroImage.setAttribute('src', imageUrl);
              if (imageSrcset) {
                heroImage.setAttribute('srcset', imageSrcset);
              }
              heroImage.style.opacity = '1';
            }, 120);
          };

          nextImage.onload = applyImage;
          nextImage.onerror = applyImage;
          if (imageSrcset) {
            nextImage.srcset = imageSrcset;
          }
          nextImage.src = imageUrl;
        };

        const updateVariant = (index, forceUpdate = false) => {
          const navItem = navItems.find((item) => Number(item.dataset.index) === index);
          const device = getDevice();

          if (!navItem) return;
          setActiveState(index);
          swapImage(navItem, device, forceUpdate || device !== currentDevice || index !== currentIndex);
          currentDevice = device;
          currentIndex = index;
        };

        const goToNext = () => {
          const nextIndex = (currentIndex + 1) % navItems.length;
          updateVariant(nextIndex, true);
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (!autoplayEnabled || navItems.length <= 1) return;
          autoplayTimer = window.setInterval(() => {
            if (!isPaused) goToNext();
          }, autoplaySpeed);
        };

        const stopAutoplay = () => {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        container.addEventListener('mouseenter', () => { isPaused = true; });
        container.addEventListener('mouseleave', () => { isPaused = false; });
        container.addEventListener('focusin', () => { isPaused = true; });
        container.addEventListener('focusout', () => { isPaused = false; });

        container.homeScooterUpdate = updateVariant;

        navItems.forEach((item) => {
          const index = Number(item.dataset.index);
          item.addEventListener('click', () => {
            updateVariant(index, true);
            startAutoplay();
          });
          item.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              updateVariant(index, true);
              startAutoplay();
            }
          });
        });

        const handleDeviceChange = () => updateVariant(currentIndex, true);
        if (typeof mediaQuery.addEventListener === 'function') {
          mediaQuery.addEventListener('change', handleDeviceChange);
        } else if (typeof mediaQuery.addListener === 'function') {
          mediaQuery.addListener(handleDeviceChange);
        }

        updateVariant(0);
        startAutoplay();
      });
    };

    document.addEventListener('DOMContentLoaded', () => setupHomeScooters());
    document.addEventListener('shopify:section:load', (event) => setupHomeScooters(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const selected = event.target.closest('[data-home-scooter-block], [data-home-scooter-nav]');
      const container = selected && selected.closest('[data-home-scooter]');
      if (!selected || !container || typeof container.homeScooterUpdate !== 'function') return;
      container.homeScooterUpdate(Number(selected.dataset.index), true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
